<template>
    <section class="notenruecknahme-sv">
        <FormGroupBuilder :fields="ioFields" :data="data" :refresh="validationRefresh" />
        <NotenartruecknahmeSV
            :sv_id="data.sv_id"
            :werk_id="data.werk_id"
            :notenId="notenId"
            :notentyp="notentyp"
            @update="changedValues"
        />
    </section>
</template>

<script>
import Validation from "@/mixins/Validation/Validation";
import Toaster from "@/mixins/Toaster/Toaster";
import { ApiFactory } from "@/api/ApiFactory.js";
import FormGroupBuilder from "@/components/FormGroupBuilder/FormGroupBuilder";
import NotenartruecknahmeSV from "@/components/Notentransfer/NotenartruecknahmeSV/NotenartruecknahmeSV";

const NotenverwaltungApi = ApiFactory.get("notenverwaltung");
const NotentransferSVApi = ApiFactory.get("notentransferSV");

export default {
    name: "NotenrücknahmeSV",
    mixins: [Validation, Toaster],
    components: {
        FormGroupBuilder,
        NotenartruecknahmeSV
    },
    props: ["svId", "werkId", "notenId", "notentyp", "validationData"],
    data() {
        return {
            ioFields: {
                sv_id: {
                    key: "sv_id",
                    label: "Stimmvertreter",
                    type: "select",
                    options: [
                        {
                            text: "Stimmvertreter auswählen...",
                            value: null
                        }
                    ],
                    mandatory: true,
                    disabled: true
                },
                werk_id: {
                    key: "werk_id",
                    label: "Konzert",
                    type: "filteredselect",
                    options: [
                        {
                            text: "Stimmvertreter auswählen...",
                            value: null
                        }
                    ],
                    disabled: true,
                    mandatory: true
                },
                hr: {
                    key: "hr",
                    type: "hr"
                }
            },
            data: {
                werk_id: this.werkId,
                sv_id: this.svId || null,
                returned: {}
            },
            sv: []
        };
    },
    created() {
        this.fetchSV();
    },
    watch: {
        data: {
            handler(val) {
                this.cleanValidationData(this.ioFields);
                this.$emit("update", val);
            },
            deep: true
        },
        "data.werk_id": {
            handler() {
                this.dataSet();
            }
        },
        "data.sv_id": {
            handler(val) {
                if (val) {
                    this.fetchWerke();
                } else {
                    this.resetWerke();
                }
                this.dataSet();
            },
            immediate: true
        },
        validationData: {
            handler(val) {
                this.cleanValidationData(this.ioFields);
                if (typeof val.json.validation === "object") {
                    this.handleValidationData(val, this.ioFields);
                } else {
                    this.makeToast(
                        "Fehler beim Speichern der Transaktion",
                        val.json.validation,
                        "danger"
                    );
                }
            }
        }
    },
    methods: {
        async fetchSV() {
            this.ioFields.sv_id.disabled = true;
            const response = await NotenverwaltungApi.getSV();
            if (response.ok) {
                const sv = response.json.collection;
                sv.forEach(item => {
                    this.ioFields.sv_id.options.push({
                        value: item.id,
                        text: item.vorname + " " + item.name
                    });
                });
                this.sv = sv;
            }
            this.ioFields.sv_id.disabled = false;
        },
        async fetchWerke() {
            this.ioFields.werk_id.disabled = true;
            this.ioFields.werk_id.options = [
                {
                    text: "Werke werden geladen...",
                    value: null
                }
            ];
            const response = await NotentransferSVApi.getWerkeForSV(
                this.data.sv_id
            );
            if (response.ok) {
                const werke = response.json.collection;
                this.ioFields.werk_id.options = werke.map(item => {
                    return {
                        value: item.id,
                        text:
                            item.bezeichnung +
                            " (" +
                            this.$moment(item.verfallsdatum).format("DD.MM.Y") +
                            ")"
                    };
                });
            }
            this.ioFields.werk_id.disabled = false;
        },
        resetWerke() {
            this.data.werk_id = undefined;
            this.ioFields.werk_id.disabled = true;
            this.ioFields.werk_id.options = [
                {
                    text: "Stimmvertreter auswählen...",
                    value: null
                }
            ];
        },
        changedValues(returnedObj) {
            this.data.returned[returnedObj.noten_art_id] = returnedObj;
            this.$emit("update", this.data);
        },
        dataSet() {
            this.data.returned = {};
        }
    }
};
</script>